import type { ConfigFormData } from 'shared/types/configuration-service';
import ApiMethods from 'shared/api/api-methods';
import { queryOptions } from '@tanstack/react-query';
import { configKeys } from '@/enteties/config/api/config.query-keys';
import { handleMutateApiError } from 'shared/api/utils';

const url = '/projects';

export const projectConfiguration = {
  getConfig: async function getConfig(slug: string): Promise<ConfigFormData> {
    try {
      const res = await ApiMethods.get(`${url}/${slug}/config`);
      if (!res.ok) throw Error(`${res.status}`);
      return await res.json();
    } catch (e) {
      return {};
    }
  },
  getProjectConfigQueryOptions: ({ slug }: { slug: string }) =>
    queryOptions({
      queryKey: configKeys.projectConfig(slug),
      queryFn: () => projectConfiguration.getConfig(slug),
    }),
};

export async function postProjectConfig(slug: string, config: ConfigFormData) {
  const res = await ApiMethods.post(`${url}/${slug}/config`, config);
  if (!res.ok) {
    return handleMutateApiError(res);
  }
  return { status: res.ok };
}

export const configurations = {
  getAllConfigurations:
    async function getAllConfigurations(): Promise<ConfigFormData> {
      const res = await ApiMethods.get('/configurations');
      if (!res.ok) throw Error(`${res.status}`);
      return await res.json();
    },
  getAllConfigurationsQueryOptions: () =>
    queryOptions({
      queryKey: configKeys.allConfigs,
      queryFn: () => configurations.getAllConfigurations(),
      select: (data) => data.availableParameters,
    }),
};
